import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import PendingApproval from "@/pages/PendingApproval";

interface ApprovalRouteProps {
  children: React.ReactNode;
}

const ApprovalRoute = ({ children }: ApprovalRouteProps) => {
  const { user, userStatus, loading } = useAuth()

  if (loading) {
    return <></>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Password non ancora impostata — qualsiasi ruolo
  if (userStatus === 'invited') {
    return <Navigate to="/set-password" replace />;
  }

  // In attesa di approvazione o accesso negato
  if (userStatus === 'pending' || userStatus === 'rejected') {
    return <PendingApproval />;
  }

  // approved — accesso concesso
  return <>{children}</>;
};

export default ApprovalRoute; 